import { render, staticRenderFns } from "./SelectedArtist.vue?vue&type=template&id=b6c7b8f6&scoped=true&"
import script from "./SelectedArtist.vue?vue&type=script&lang=js&"
export * from "./SelectedArtist.vue?vue&type=script&lang=js&"
import style0 from "./SelectedArtist.vue?vue&type=style&index=0&id=b6c7b8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c7b8f6",
  null
  
)

export default component.exports